// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"6449e044","455":"c44f8520"}[chunkId] + ".chunk.js";
};